import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import Hidden from '@material-ui/core/Hidden';
import MenuIcon from '@material-ui/icons/Menu';
import { Route, Switch } from "react-router";
import EventsList from './EventsList';
import EventDetails from './EventDetails';

import Loading from 'react-loading-bar'
import 'react-loading-bar/dist/index.css'
import EventTime from './EventTime';
import SearchInput from './SearchInput';
import EventSearch from './EventSearch';

const drawerWidth = 330;

const dummy = 49;

const styles = theme => ({
  root: {
    flexGrow: 1,
    zIndex: 1,
    overflow: 'hidden',
    display: 'flex',
    width: '100%',
    height: '100%',
    minHeight: 700,
  },
  flex: {
    flexGrow: 1,
  },
  appBar: {
    position: 'fixed',
    marginLeft: drawerWidth,
    [theme.breakpoints.up('md')]: {
      width: `calc(100% - ${drawerWidth}px)`,
    },
  },
  navIconHide: {
    [theme.breakpoints.up('md')]: {
      display: 'none',
    },
    marginLeft: -12,
    marginRight: 5,
  },
  title: {
    [theme.breakpoints.up('sm')]: {
      fontSize: theme.typography.title.fontSize,
    },
    fontSize: theme.typography.subheading.fontSize,
    flexGrow: 1,
  },
  subtitle: {
    fontSize: 12,
  },
  toolbar: theme.mixins.toolbar,
  drawerPaper: {
    width: drawerWidth,
    [theme.breakpoints.up('md')]: {
      position: 'fixed',
    },
  },
  content: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.default,
    padding: theme.spacing.unit * 3,
    maxWidth: `calc(100% - ${dummy}px)`,
  },
});

class ISSDrawer extends React.Component {
  
  state = {
    mobileOpen: false,
    title: '37th International Seating Symposium',
    subtitle: '',
    curEvtId: -1,
    curDtlId: -1,
    propEventList: {},
    evtId: -1,
    dtlId: -1,
    searchResults: [],
    searchKeyword: '',
  };

  handleDrawerToggle = () => {
    this.setState({ mobileOpen: !this.state.mobileOpen });
  };
  
  render() {
    
    const { classes, theme, events, showLoading,displayLoadIndicator } = this.props;
  
    //fetch('https://www.seatingsymposium.us:8543/auth/realms/rstce/protocol/openid-connect/token', {method: 'POST', headers: {},body: 'grant_type=password&client_id=meteor-app&username=iss@seatingsymposium.us&password=gotoiss'}).then(response => response.json()).then(result => this.onSetResult(result));
    return (
      <div className={classes.root}>
        <Loading
          show={showLoading}
          color="red"
          showSpinner={false}
        />
        <AppBar className={classes.appBar}>
          <Toolbar>
            <IconButton
              color="inherit"
              aria-label="open drawer"
              onClick={this.handleDrawerToggle}
              className={classes.navIconHide}
            >
              <MenuIcon />
            </IconButton>
            <Hidden smDown>
              <Typography className={classes.title}  color="inherit" noWrap>
                {this.state.title} - {this.state.subtitle}
              </Typography>
            </Hidden>
            <Hidden mdUp>
              <div className={classes.flex}>
                <Typography className={classes.title} color="inherit" noWrap>
                  {this.state.title}
                </Typography>
                <Typography className={classes.subtitle} color="inherit" noWrap>
                  {this.state.subtitle}
                </Typography>
              </div>
            </Hidden>
            <EventTime events={events} evtId={this.state.curEvtId} dtlId={this.state.curDtlId}/>
          </Toolbar>
        </AppBar>
        <Hidden mdUp>
          <Drawer
            variant="temporary"
            anchor={theme.direction === 'rtl' ? 'right' : 'left'}
            open={this.state.mobileOpen}
            onClose={this.handleDrawerToggle}
            
            classes={{
              paper: classes.drawerPaper,
            }}
            ModalProps={{
              keepMounted: true, // Better open performance on mobile.
            }}
          >
            <div className={classes.toolbar}>
              <SearchInput toggleDrawer={() => {this.handleDrawerToggle()}} updateSearchResults={(keyword,results) => this.setState({searchResults: results,searchKeyword: keyword})} displayLoadIndicator={displayLoadIndicator} updateTitle={(theTitle,subTitle,evtId,dtlId) => this.setState({title: theTitle,subtitle: subTitle,curEvtId: evtId,curDtlId: dtlId})} />
            </div>
            
            <EventsList updateTitle={(theTitle,subTitle,evtId,dtlId) => {this.setState({title: theTitle,subtitle: subTitle,curEvtId: evtId,curDtlId: dtlId});this.handleDrawerToggle()}} events={events} eventId={this.state.evtId} detailId={this.state.dtlId} />
              
          </Drawer>
        </Hidden>
        <Hidden smDown implementation="css">
          <Drawer
            variant="permanent"
            open
            classes={{
              paper: classes.drawerPaper,
            }}
          >
            <div className={classes.toolbar}>
              <SearchInput toggleDrawer={() => {this.handleDrawerToggle()}} updateSearchResults={(keyword,results) => this.setState({searchResults: results,searchKeyword: keyword})} displayLoadIndicator={displayLoadIndicator} updateTitle={(theTitle,subTitle,evtId,dtlId) => this.setState({title: theTitle,subtitle: subTitle,curEvtId: evtId,curDtlId: dtlId})} />
            </div>

            <EventsList updateTitle={(theTitle,subTitle,evtId,dtlId) => this.setState({title: theTitle,subtitle: subTitle,curEvtId: evtId,curDtlId: dtlId})} events={events} eventId={this.state.evtId} detailId={this.state.dtlId} />
            
          </Drawer>
        </Hidden>
        <main className={classes.content}>
          <div className={classes.toolbar} />
          
            <Switch>
              <Route exact path='/event-schedule' render={(props) => <EventDetails {...props} events={events} updateTitle={(theTitle,subTitle,evtId,dtlId) => this.setState({title: theTitle,subtitle: subTitle,curEvtId: evtId,curDtlId: dtlId})} displayLoadIndicator={displayLoadIndicator} setEvent={(theEvtId,theDtlId) => { this.setState({evtId: theEvtId,dtlId:theDtlId})}} />}/>
              <Route exact path="/event-schedule/event/:id/:dtlId/at/:schId" render={(props) => <EventDetails {...props} events={events} updateTitle={(theTitle,subTitle,evtId,dtlId) => this.setState({title: theTitle,subtitle: subTitle,curEvtId: evtId,curDtlId: dtlId})} displayLoadIndicator={displayLoadIndicator} setEvent={(theEvtId,theDtlId) => { this.setState({evtId: theEvtId,dtlId:theDtlId})}} />}/>
              <Route exact path="/event-schedule/event/:id/:dtlId" render={(props) => <EventDetails {...props} events={events} updateTitle={(theTitle,subTitle,evtId,dtlId) => this.setState({title: theTitle,subtitle: subTitle,curEvtId: evtId,curDtlId: dtlId})} displayLoadIndicator={displayLoadIndicator} setEvent={(theEvtId,theDtlId) => { this.setState({evtId: theEvtId,dtlId:theDtlId})}} />}/>
              <Route exact path='/event-schedule/event/:id' render={(props) => <EventDetails {...props} events={events} updateTitle={(theTitle,subTitle,evtId,dtlId) => this.setState({title: theTitle,subtitle: subTitle,curEvtId: evtId,curDtlId: dtlId})} displayLoadIndicator={displayLoadIndicator} setEvent={(theEvtId,theDtlId) => { this.setState({evtId: theEvtId,dtlId:theDtlId})}} />}/>
              <Route exact path='/event-schedule/event/:id/at/:schId' render={(props) => <EventDetails {...props} events={events} updateTitle={(theTitle,subTitle,evtId,dtlId) => this.setState({title: theTitle,subtitle: subTitle,curEvtId: evtId,curDtlId: dtlId})} displayLoadIndicator={displayLoadIndicator} setEvent={(theEvtId,theDtlId) => { this.setState({evtId: theEvtId,dtlId:theDtlId})}} />}/>
              <Route exact path='/event-schedule/search' render={(props) => <EventSearch {...props} results={this.state.searchResults} updateTitle={(theTitle,subTitle,evtId,dtlId,searchText) => this.setState({title: theTitle,subtitle: subTitle,curEvtId: evtId,curDtlId: dtlId, searchKeyword: searchText})} displayLoadIndicator={displayLoadIndicator} updateSearchResults={(results) => this.setState({searchResults: results})} searchKeyword={this.state.searchKeyword} />}/>
            </Switch>
          
        </main>
      </div>
    );
  }
}

ISSDrawer.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
  events: PropTypes.array.isRequired,
  displayLoadIndicator: PropTypes.func,
};

export default withStyles(styles, { withTheme: true })(ISSDrawer);